<template>
  <div class="home">
    <v-stepper v-model="step" v-if="stepCount >= 1" flat class="pa-2"  >
      <v-stepper-header v-if="stepCount > 1 && stepCount < 5">
        <v-stepper-step
          v-for="(item, index) in dataGet.pages"
          :key="index"
          :complete="step > index + 1"
          :step="index + 1"
        >
          {{ item.title }}
        </v-stepper-step>
      </v-stepper-header>
      <v-card v-else  flat>
        <v-card-title>
          <v-chip class="ma-1" color="primary" dark>{{ step }}</v-chip>
          {{ dataGet.pages[step - 1].title }}
        </v-card-title>
      </v-card>
      <v-form ref="form" lazy-validation class="pa-1">
        <v-alert v-if="dataGet.pages[step - 1].message" dense color="cyan" border="left" colored-border  elevation="1" flat>
          {{ dataGet.pages[step - 1].message }}</v-alert
        >
        <v-row>
          <v-col
            v-for="(item, index) in dataGet.pages[step - 1].elements"
            :key="index"
            cols="12"
          >
            <Form :field="item" />
          </v-col>
        </v-row>
        <div>
          <Submit :data-field="{}" />
        </div>
      </v-form>
    </v-stepper>
  </div>
</template>

<script>
import Form from "../components/Form.vue";

import Submit from "../components/Submit.vue";

export default {
  name: "Home",
  components: {
    Submit,
    Form,
  },
  computed: {
    dataGet: {
      get() {
        return this.$store.state.dataGet;
      },
    },
    submitLoading: {
      get() {
        return this.$store.state.submitLoading;
      },
    },
    step: {
      get() {
        return this.$store.state.step;
      },
    },
    stepCount: {
      get() {
        return this.$store.state.stepCount;
      },
    },
  },
  data() {
    return {};
  },
  mounted() {
    this.fetchData();
  },
  methods: {
    async fetchData() {
      this.setLoading(true);
      await this.axios
        .get(this.$store.state.url)
        .then((Response) => {
          this.setLoading(false);
          if (Response.status == 200) {
            if (Response.data.success) {
              this.$store.commit("updateDataGet", Response.data.data);
              let length = Object.keys(Response.data.data.pages).length
                ? Object.keys(Response.data.data.pages).length
                : 1;
              this.$store.commit("updateStepCount", length);
              this.syncDataPost();
            } else {
              this.$store.commit("submitFormStatus", {
                status: false,
                type: Response.data.message.type,
                message: Response.data.message.error,
              });
            }
          } else {
            this.$store.commit("submitFormStatus", {
              status: false,
              message: Response.data.message,
            });
          }
        })
        .catch((Error) => {
          console.log("http Err:", Error.response);
          this.$store.commit("submitFormStatus", {
            status: true,
            type: "error",
            message: "فرم مورد نظر یافت نشد ...",
          });
          window.setTimeout(function () {
            window.location.href = "https://blog.shippoll.ir/";
          }, 2000);
        });
      this.setLoading(false);
    },

    setLoading(status) {
      this.$store.commit("updateSubmitLoading", status);
    },
    syncDataPost() {
      let pages = this.dataGet.pages;
      let dataPost = this.$store.state.dataPost;
      let hiddenValue = window.hiddenValue;
      console.log("hhh", hiddenValue);
      pages.map((Item) => {
        let elements = Item.elements;
        elements.map((itemElement) => {
          // for set default value in states
          if (itemElement["value"])
            dataPost[itemElement["name"]] = itemElement["value"];
          if (
            typeof hiddenValue == "object" &&
            hiddenValue &&
            hiddenValue[itemElement["name"]] &&
            hiddenValue[itemElement["name"]][0]
          )
            dataPost[itemElement["name"]] = hiddenValue[itemElement["name"]];
        });
      });

      this.$store.commit("updateDataPost", dataPost);
    },
  },
};
</script>
